module.exports = __webpack_public_path__ + "static/media/expand-more-icon2.d022480b.svg";